export default "__VITE_ASSET__3CSMzXjK__"